import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';

import template from './url-template.pug';
import { showPopoverTableView } from '../../../../page/index';

export class OptionsUrlView extends Backbone.View {
  initialize({
    i18n,
    model,
    options,
  }) {
    this.i18n = i18n;
    this.model = model;
    this.options = options;
  }

  get events() {
    return {
      'click .import-options-link.TrackingTemplate': 'viewTrackingTemplateDetails',
      'click .import-options-link.FinalUrl': 'viewFinalUrlDetails',
    };
  }

  viewTrackingTemplateDetails(event) {
    const data = _.map(this.model.TrackingTemplateValue, ({
      googleCustomerId,
      googleAccountName,
      trackingTemplate,
    }) => ({
      AccountName: `${googleAccountName} (${googleCustomerId})`,
      urlContents: trackingTemplate || this.i18n.getString('Import_ImportOptions_TrackingTemplate_NotAvailable'),
    }));

    showPopoverTableView(
      event.target,
      ['TrackingTemplateView'],
      '',
      [{
        bodyClasses: 'AccountName',
        name: 'AccountName',
        title: this.i18n.get('GoogleImport_MicrosoftAdvertising_GoogleAccounts'),
      }, {
        bodyClasses: 'urlContents',
        name: 'urlContents',
        title: this.i18n.getString('ColumnName_TrackingTemplate'),
      }],
      data,
      this.i18n
    );
  }

  viewFinalUrlDetails(event) {
    const data = _.map(this.model.FinalUrlSuffixValue, ({
      googleCustomerId,
      googleAccountName,
      finalUrlSuffix,
    }) => ({
      AccountName: `${googleAccountName} (${googleCustomerId})`,
      urlContents: finalUrlSuffix || this.i18n.getString('Import_ImportOptions_TrackingTemplate_NotAvailable'),
    }));

    showPopoverTableView(
      event.target,
      ['FinalUrlSuffixView'],
      '',
      [{
        bodyClasses: 'AccountName',
        name: 'AccountName',
        title: this.i18n.get('GoogleImport_MicrosoftAdvertising_GoogleAccounts'),
      }, {
        bodyClasses: 'urlContents',
        name: 'urlContents',
        title: this.i18n.getString('ColumnName_FinalUrlSuffix'),
      }],
      data,
      this.i18n
    );
  }

  render() {
    this.$el.html(template({
      i18n: this.i18n,
      field: this.options.field,
      isCustomerLevel: this.model.isCustomerLevel,
      isHideUrlDetailView: this.model.isHideUrlDetailView,
    }));

    ko.applyBindings(this.options.viewModel, this.el);

    return this;
  }
}
